import React from 'react';

const UserActionButtons = ({ buttons }) => {
  return (
    <div className={`role-buttons`}>
      {buttons &&
        buttons.map(button => (
          <div key={button.key} className={`role-button`} onClick={() => button.onPress()}>
            {button.title}
          </div>
        ))}
    </div>
  );
};

export default UserActionButtons;
